import { StyledSavedCardsSkeletonWrapper, StyledSavedCardSkeleton } from './SkeletonSavedCreditCards.styled';

export function SkeletonSavedCreditCards({ skeletonsToDraw }: { skeletonsToDraw: number }) {
  return (
    <StyledSavedCardsSkeletonWrapper>
      {Array.from({ length: skeletonsToDraw }, (element, index) => index).map((cardNum) => (
        <StyledSavedCardSkeleton animated key={cardNum} />
      ))}
    </StyledSavedCardsSkeletonWrapper>
  );
}
